import withCheckedInput from '../../../decorators/form/withCheckedInput';
import CheckedInput from './CheckedInput';

import css from './radio-button.module.scss';

export const RadioButton = (props) => (
  <CheckedInput
    spanClassName={css.span}
    iconClassName={css.icon}
    type="radio"
    {...props}
  />
);

export default withCheckedInput(RadioButton);
